/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecordingThumbnailEvidenceImage
 */
export interface RecordingThumbnailEvidenceImage {
    /**
     * 
     * @type {string}
     * @memberof RecordingThumbnailEvidenceImage
     */
    objectKey: string;
    /**
     * 
     * @type {boolean}
     * @memberof RecordingThumbnailEvidenceImage
     */
    isCover: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RecordingThumbnailEvidenceImage
     */
    isPreferred: boolean;
}

/**
 * Check if a given object implements the RecordingThumbnailEvidenceImage interface.
 */
export function instanceOfRecordingThumbnailEvidenceImage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "objectKey" in value;
    isInstance = isInstance && "isCover" in value;
    isInstance = isInstance && "isPreferred" in value;

    return isInstance;
}

export function RecordingThumbnailEvidenceImageFromJSON(json: any): RecordingThumbnailEvidenceImage {
    return RecordingThumbnailEvidenceImageFromJSONTyped(json, false);
}

export function RecordingThumbnailEvidenceImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordingThumbnailEvidenceImage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objectKey': json['objectKey'],
        'isCover': json['isCover'],
        'isPreferred': json['isPreferred'],
    };
}

export function RecordingThumbnailEvidenceImageToJSON(value?: RecordingThumbnailEvidenceImage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objectKey': value.objectKey,
        'isCover': value.isCover,
        'isPreferred': value.isPreferred,
    };
}

